<script>
import { mapActions } from 'vuex';
import { showToast } from '@inscribe/signal';

export default {
  props: {
    newRulesCollection: {
      type: Array,
      default: null,
    },
  },
  watch: {
    newRulesCollection(value) {
      if (value) {
        this.saveRules();
      }
    },
  },
  methods: {
    ...mapActions({
      updateConfigRules: 'updateConfigRules',
      saveRules: 'saveRules',
    }),
    onClose() {
      this.$emit('on-close');
    },
    saveRules() {
      this.updateConfigRules({ rules: this.newRulesCollection }).then(
        () => {
          this.$emit('on-saved');
          showToast({
            text: 'Fraud rules updated',
          });
        },
        (error) => {
          showToast({
            title: 'Something went wrong saving your config',
            text: error?.response?.data?.message,
            isError: true,
          });
        },
      );
    },
  },
};
</script>

<template>
  <div class="rule-save"></div>
</template>
